import React from 'react';
import { PerksInfo } from './PerksInfo';
import { sassOptOut } from '../../../utils/sassOptOut';
import { VerifyLayoutProvider } from '../customers/hooks/useVerifyLayout/useVerifyLayout';
import { PerksSignupWrapper } from '../customers/components/phoneVerify/themeLayouts/perks/PerksSignupWrapper';
import { Portal } from '../../../components/portal/Portal';

export const PerksInfoPortal = () => {
  const container = window.document.getElementById('react-root-perks-info');
  if (!container) return null;

  sassOptOut('forms');

  return (
    <>
      <Portal container={container}>
        <VerifyLayoutProvider isBlankLayout>
          <PerksSignupWrapper isSitewide>
            <PerksInfo />
          </PerksSignupWrapper>
        </VerifyLayoutProvider>
      </Portal>
    </>
  );
};
